export default "__VITE_ASSET__d1f37ef9__"